import React from 'react';
import './Footer.css';
import { Link } from 'react-scroll';
import {FaFacebook} from 'react-icons/fa';
import {BsTwitter} from 'react-icons/bs';
import {AiFillLinkedin} from 'react-icons/ai';
import {FiInstagram} from 'react-icons/fi';
import Vip from '../../Assets/vip.gif';

const Footer = () => {
    return (
        <>
            <div className="footer">
                <div className="waves">
                    <div className="wave" id='wave1'></div>
                    <div className="wave" id='wave2'></div>
                    <div className="wave" id='wave3'></div>
                    <div className="wave" id='wave4'></div>
                </div>
                <div className="footer-wrapper">
                    <div className="footer-item">
                        <div className="footer-logo">
                            <span><FaFacebook size={31} /></span>
                            <span><BsTwitter size={31} /></span>
                            <span><AiFillLinkedin size={31} /></span>
                            <span><FiInstagram size={31} /></span>
                        </div>

                        <ul>
                            <Link to='home' smooth={true}><li>Home</li></Link>
                            <Link to='work' smooth={true}><li>How it Work</li></Link>
                            <Link to='mentor' smooth={true}><li>Mentors</li></Link>
                            <Link to='book' smooth={true}><li>Book Class</li></Link>
                            <Link to='about' smooth={true}><li>About Us</li></Link>
                            <Link to='contact' smooth={true}><li>Contact Us</li></Link>
                        </ul>
                    </div>
                    <div className="footer-copy">
                        <p>@2022 Hasnain Irfan | All Right Reserved</p>
                        <img src={Vip} alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer